// @ts-generator-hash: 9890f91aefc27b4c85fdeeda17ac5ccecbd1080b1740f4eb372e5b9cba576a55
// Generation date: 1/15/2026 2:23:15 PM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.PhaseAction
export enum PhaseAction {
  ADD = 5,
  RELEASE = 10,
  SUBMIT = 20,
  REQUESTREVISION = 25,
  APPROVE = 30,
  GENERATE_REPORT = 40,
}
